import { useContext } from 'react';
import { LoadingContext } from '../components/contexts/LoadingContext';

export default function useLoading() {
  const { startLoading, endLoading } = useContext(LoadingContext);

  return (callback: () => Promise<void>) => {
    const loadingId = startLoading();
    callback().finally(() => endLoading(loadingId));
  };
}
